import styles from './ShareTo.module.scss';
import { FacebookShareButton, LinkedinShareButton, WhatsappShareButton } from 'react-share';
import ShareFacebook from '../../../../../Icons/ShareFacebook';
import ShareLinkedin from '../../../../../Icons/ShareLinkedin';
import ShareWhatsApp from '../../../../../Icons/ShareWhatsApp';

export default function ShareTo({ fields }) {
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const shareText = fields?.ShareText?.value || 'Share to:';

  return (
    <>
      <div className={styles.line}></div>
      <div className={styles.wrapper}>
        <p className={styles.text}>{shareText}</p>
        <div className={styles.socialNetworks}>
          <FacebookShareButton url={currentUrl}>
            <ShareFacebook />
          </FacebookShareButton>
          <LinkedinShareButton url={currentUrl}>
            <ShareLinkedin />
          </LinkedinShareButton>
          <WhatsappShareButton url={currentUrl}>
            <ShareWhatsApp />
          </WhatsappShareButton>
        </div>
      </div>
    </>
  );
}
